import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SafariIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m5.5 5.5-2 4 4-2m-2-2 4-2-2 4m-2-2 2 2m5-1a6 6 0 1 1-12 0 6 6 0 0 1 12 0" /></svg>
  );
}

export default SafariIcon;
